import React from 'react';
import './WhyCognitva.css';
import siteConfig from '../../configuration/siteConfiguration';

const features = [
  {
    "title": "Patent-Pending Intelligence Architecture",
    "description": "A modular, reusable AI core (WEAVE™) engineered to scale across regulated domains without rebuilding systems or logic.",
    "icon": "patent-pending-intelligence-architecture.svg"

  },
  {
    "title": "Semantic + Predictive Intelligence",
    "description": "Combines deep language understanding with real-time data modeling to deliver context-aware, decision-grade intelligence-not probabilistic responses.",
    "icon": "semantic--predictive-ai.svg"
  },
  {
    "title": "Domain-Aware Automation",
    "description": "Pre-configured workflows trained on regulatory, clinical, financial, and legal logic-built for how professionals actually operate in high-stakes environments.",
    "icon": "domain-aware-automation.svg"
  },
  {
    "title": "Faster Time-to-Impact",
    "description": "An 80% reusable AI core enables plug-and-play deployment across industries, cutting integration time, cost, and time-to-ROI.",
    "icon": "faster-time-to-impact.svg"
  },
  {
    "title": "Human + AI Collaboration",
    "description": "Human-in-the-loop by design. AI assists decision-making while accountability, oversight, and control remain with experts.",
    "icon": "human--ai-collaboration.svg"
  },
  {
    "title": "Simple to Deploy",
    "description": "Legacy-friendly, cloud-native, API-driven architecture that integrates seamlessly with existing systems-no rip-and-replace required.",
    "icon": "simple-to-deploy.svg"
  },
  {
    "title": "Built on Trust",
    "description": "Transparent, explainable AI with full audit trails, policy controls, and defensible decision logic-ready for regulators, auditors, and courts.",
    "icon": "built-on-trust.svg"
  },
  {
    "title": "Engineered for Accuracy",
    "description": "Knowledge-driven AI trained on curated, validated datasets with continuous feedback loops to reduce hallucinations and improve reliability over time.",
    "icon": "engineered-for-accuracy.svg"
  },
  {
    "title": "Enterprise-Grade Security",
    "description": "End-to-end encryption, role-based access control, and compliance-ready architecture aligned with DPDP, HIPAA, GDPR, RBI/SEBI, and ISO/IEC 27001-ready standards.",
    "icon": "enterprise-grade-security.svg"
  }
];

const WhyCognitva = () => {
  return (
    <section className="why-cognitva-section">
      <div className="wave-bg">
        <img src="/images/wave.svg" alt="" />
      </div>
      <div className="why-cognitva-container">
        <div className="why-cognitva-header">
          <div className="why-cognitva-intro">
            <div className="why-cognitva-line"></div>
            <span className="why-cognitva-badge">WHY COGNITVA</span>
          </div>
          <h2 className="why-cognitva-title">AI that Understands. Automates. Elevates.</h2>
          <p className="why-cognitva-description">
            Cognitva is not just another AI platform. We're building the next-generation Cross-Industry Intelligence Platform (WEAVE™) - where deep semantic understanding meets domain-specific automation. Whether you're navigating complex legal processes, clinical diagnostics, or regulatory compliance, <strong>Cognitva orchestrates intelligent outcomes at scale.</strong>
          </p>
          <p className="why-cognitva-sub-description">Built for complexity. Designed for action.</p>
        </div>

        <div className="why-cognitva-grid">
          {features.map((feature, index) => (
            <div className="why-cognitva-card" key={index}>
              <div className="why-cognitva-icon-container">
                <img src={`${siteConfig.assetBaseUrl}/icons/homepage/why-cognitva/${feature.icon}`} alt="icon" className="why-cognitva-icon" />
              </div>
              <h3 className="why-cognitva-card-title">{feature.title}</h3>
              <p className="why-cognitva-card-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyCognitva; 